import React, { useContext } from 'react'

import { SelectionContext} from '../../store/selection-context-provider'
import InputCheckbox from '../../utils/controls/input-checkbox'

interface Props {
  title?: string
}
const CustomerDashboardInquiresTableHead = ({title}: Props) => {
  const selection = useContext(SelectionContext)

  return (
    <thead>
      <tr>
       <th>
          <InputCheckbox
            formClassName='form-horizontal font-0'
            inputProps={{
              checked: selection.allCheckboxIsChecked,
              id: 'all',
              label: 'All',
              name: 'Input Check',
              type: 'checkbox',
            }}
            onChange={selection.handleAllCheckboxChange}
          />
        </th>
        <th aria-label='Inquiry ID' tabIndex={0}>
          Inquiry ID
        </th>
        <th aria-label='Section' tabIndex={0}>
          Section
        </th>
        <th aria-label='Category' tabIndex={0}>
          Category
        </th>
        <th aria-label='Current Servicing Unit' tabIndex={0}>
          Current Servicing Unit
        </th>
        <th aria-label='Submitted date' tabIndex={0}>
          Submitted date
        </th>
        <th aria-label='Status Modified' tabIndex={0}>
          Status Modified
        </th>
        <th aria-label='Status' tabIndex={0}>
          Status
        </th>
        <th aria-label='# of Days' tabIndex={0}>
          # of Days
        </th>
        <th className='font-0'>Delete Icon</th>
      </tr>
    </thead>
  )
}

export default CustomerDashboardInquiresTableHead
